import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { Theme, useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { web3InteractionSuccessStyles } from './web3InteractionSuccessStyles';
import { useWeb3InteractionSuccess } from './useWeb3InteractionSuccess';
import { Web3InteractionSuccessType } from './Web3InteractionSuccessType';

export interface IInvestmentSuccessProps {
  successType: Web3InteractionSuccessType;
}

export const Web3InteractionSuccess = ({
  successType
}: IInvestmentSuccessProps) => {
  const theme: Theme = useTheme();
  const { t } = useTranslation();
  const isDark = theme.palette.mode === 'dark';
  const classes = web3InteractionSuccessStyles(theme, isDark);

  const { title, continueAction, SuccessContent } =
    useWeb3InteractionSuccess(successType);

  const clickHandler = () => {
    continueAction?.();
  };

  return (
    <Grid
      container
      alignItems='center'
      justifyContent='center'
      direction='column'
      sx={classes.container}
    >
      <Paper sx={classes.paperContainerSummary}>
        <Grid
          item
          container
          direction='column'
          alignItems='center'
          justifyContent='center'
          rowSpacing={1}
        >
          <Grid
            item
            container
            direction='row'
            alignItems='center'
            justifyContent='center'
          >
            <Typography variant='h4' sx={classes.title}>
              {title}
            </Typography>
            {SuccessContent && SuccessContent()}
            <Button
              variant='contained'
              color='primary'
              onClick={clickHandler}
              sx={classes.buttonContained}
            >
              {t('vesting.web3_interaction_success.button_continue')}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};
